export const weatherValues = [
  {
    value: 'sunny',
    icon: '☀️',
    label: 'Sunny',
  },
  {
    value: 'cloudy',
    icon: '☁️',
    label: 'Cloudy',
  },
  {
    value: 'raining',
    icon: '🌧',
    label: 'Raining',
  },
]
